// using umd as base, expand if necessary
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Secretlab = factory());
}(this, function () { 'use strict';

  let screen_width = window.outerWidth;
  const screen_isMobile = function() { return document.body.offsetWidth < 992 ? true : false };

  /* ==========================================================================
      Secretlab Navigate

      New Dropdown Declaration (Automatically Binded Elements)
          1: [data-navigate][data-interaction][aria-controls="#CONTAINER_ID"]
          2: #CONTAINER_ID.topple

      Accepted Values
          [data-navigate]: link, container, search
          [data-interaction]: click, hover, input(search only)

      Initialization
          new navigate(element)

      Public functions
          navigate.getInstances()               // Get all instances
          navigate.getInstances(objectType)     // (link | container | search) - Get specific instances
          navigate.getInstances(objectType)     // #element_id - Get specific instance by id
          navigate.cartRefresh()                // Minicart refresh
          navigate.cartUpdate()                 // Minicart Update Quantity; Calls cartRefresh() after

      Local functions
          navigate.getInstances()[0].toggle(boolean)
  ========================================================================== */
  const   navigate_instances = [],
          navigate_bar = document?.querySelector('nav.nav-main'),
          navigate_content = navigate_bar?.querySelector('.nav-content'),
          navigate_topple = navigate_bar?.querySelectorAll('[data-navigate][data-interaction], .topple-primary'),
          navigate_cart = navigate_bar?.querySelector('#cart_mini'),
          navigate_cart_badge = navigate_bar?.querySelector('.cart-badge'),
          navigate_search = {
              bar: navigate_bar?.querySelector('.search-bar'),
              input: navigate_bar?.querySelector('.nav-search input'),
              suggestions: navigate_bar?.querySelector('.search-suggestion'),
              results: navigate_bar?.querySelector('.search-result'),
              result_quantity: () => { return navigate_bar?.querySelector('.search-result .result-quantity').value },
              loader: navigate_bar?.querySelector('.search-loader'),
              cancel: navigate_bar?.querySelector('.search-cancel'),
              last_value: ''
          },
          $NAVIGATE_MINICART_TABLE = '#nav_dropdown_cart .cart-content',
          $NAVIGATE_LINEITEM_EXC_BUNDLE = '.line-item:not(.line-bundle)',
          $NAVIGATE_LINEITEM_BUNDLE = '.line-item[data-bundle-properties]',
          $NAVIGATE_LINEITEM_BUNDLE_PROPERTIES = 'data-bundle-properties',
          $NAVIGATE_LINEITEM_BUNDLE_MAIN = 'data-bundle-main',
          $NAVIGATE_LINEITEM_BUNDLE_TITLE = 'data-bundle-title',
          $NAVIGATE_LINEITEM_TYPE = 'data-type',
          $NAVIGATE_LINEITEM_SKU = 'data-sku',
          $NAVIGATE_LINEITEM_PRODUCT_TITLE = 'data-product-title',
          $NAVIGATE_LINEITEM_KEY = 'data-lineitem-key',
          $NAVIGATE_LINEITEM_VARIANT_TITLE = 'data-variant-title',
          $NAVIGATE_LINEITEM_VARIANT_ID = 'data-id',
          $NAVIGATE_LINEITEM_VARIANT_IMG = '.variant-img',
          $NAVIGATE_LINEITEM_VARIANT_PREORDER = 'data-preorder-formatted',
          $NAVIGATE_LINEITEM_VARIANT_CROSSSELLING = '.line-item-cross-selling',
          $NAVIGATE_LINEITEM_PRICE_SHOPIFY = 'data-shopify',
          $NAVIGATE_LINEITEM_PRICE_DIRECT = 'data-direct',
          $NAVIGATE_LINEITEM_PRICE_MSRP = 'data-msrp',
          $NAVIGATE_LINEITEM_QUANTITY = 'data-quantity',
          $NAVIGATE_LINEITEM_INDEX = 'data-index',
          $NAVIGATE_LINEITEM_STRUCTURE = `<div class="row bg-white py-2 rounded mx-0 my-2 line-item line-bundle">
                                              <div class="col-auto d-flex align-items-center">
                                                  <!-- product_img -->
                                              </div>
                                              <div class="col px-0">
                                                  <div class="strong product-title">
                                                      <a href="<!-- product_url -->"><b><!-- product_bundle_title --></b></a>
                                                  </div>
                                                  <div class="text-secondary mb-3 product-options small">
                                                      <div class="d-flex flex-column mt-1 mb-2">
                                                          <!-- product_bundle_items -->
                                                      </div>
                                                      <div class="mt-1">
                                                          <button class="option-quantity me-1" variant-id="<!-- quantity_id -->" cart-quantity="<!-- quantity_down -->" data-type="desk-decrease">-</button>
                                                          <span class="product-quantity"><!-- quantity_current --></span>
                                                          <button class="text-secondary option-quantity ms-1" variant-id="<!-- quantity_id -->" cart-quantity="<!-- quantity_up -->">+</button>
                                                      </div>
                                                  </div>
                                                  <div class="line-height">
                                                      <span class="price cart-mini-price">
                                                          <b><!-- product_bundle_price_shopify_total --></b>
                                                      </span><br>
                                                  </div>
                                              </div>
                                              <div class="col-auto d-flex">
                                                  <button class="option-remove soleil my-auto" variant-id="<!-- quantity_id -->" cart-quantity="0" data-type="desk-remove">
                                                    <div class="position-absolute" style="top: 0; left: 0; right: 0; bottom: 0; z-index: 2;"></div>  
                                                    <div class="position-relative flex-shrink-0 overflow-visible pe-none">
                                                          <div class="line position-absolute bg-secondary w-100 h-100 pe-none"></div>
                                                          <div class="line position-absolute bg-secondary w-100 h-100 pe-none"></div>
                                                      </div>
                                                  </button>
                                              </div>
                                          </div>`;
  let navigate_delayHandler = {}, // Used to manage multiple setTimeout() by element ID
      navigate_touchCancel = false;

  /*==========================================================================
      Secretlab Mobile Navigation

      It will navigate menu through slide animation
  ==========================================================================*/
  const parent = document.querySelectorAll(".nav-mobile-link-js .mobile-parent-js");
  const child = document.querySelectorAll(".nav-mobile-link-js .mobile-child-js");

  parent.forEach(link => {
      link.addEventListener('click', function handleClick(ev) {
          ev.preventDefault();
          ev.currentTarget.nextElementSibling.classList.add("active")
      });
  });

  child.forEach(link => {
      link.addEventListener('click', function handleClick(ev) {
          ev.preventDefault();
          removeActiveNavClass(ev.currentTarget)
          attachScrolledClass(true)
      });
  });

  function removeActiveNavClass(element, reset = false) {
      if(element) {
          element.closest(".nav-submenu").classList.remove("active")
      }

      if(reset) {
          const allsubmenu = document.querySelectorAll(".nav-submenu");
          allsubmenu.forEach((element) => element.classList.remove("active"))
      }
  }

  function autoCalculateSubContentHeight() {
      const windowHeight = window.innerHeight
      const navHeight = document.querySelector('.nav-main')
      const navbarHeight = document.querySelector('.nav-bar')
      const navSubContent = document.querySelectorAll('.navsub-content')
      const navPrimaryContent = document.querySelector('.nav-primary-mobile')
      const bottomSpace = 50

      const dynamicHeight = Number(windowHeight - Number(navHeight?.offsetHeight, + navbarHeight?.offsetHeight) - bottomSpace) + "px"

      navPrimaryContent.style.height = dynamicHeight
      navSubContent.forEach((el) =>  el.style.height = dynamicHeight)
  }

  function attachScrolledClass(reset = false) {
      const navSubContent = document.querySelectorAll('.navsub-content')
      if(!reset) {
          navSubContent.forEach(element => {
              element.addEventListener('scroll', function(inner) {
                  if(inner.currentTarget.scrollTop > 20) {
                      inner.currentTarget.previousElementSibling.classList.add("scrolled")
                  } else {
                      inner.currentTarget.previousElementSibling.classList.remove("scrolled")
                  }
              });
          })

          return
      }

      // to reset when navigation is close
      navSubContent.forEach(element => {
          element.scrollTo(0,0)
          element.classList.remove("scrolled")
      })
  }

  attachScrolledClass()
  autoCalculateSubContentHeight()

  window.addEventListener('resize', function() {
      autoCalculateSubContentHeight()
  });

  class navigate {
      constructor(element, state) {
          this.id = element.id != '' ? '#' + element.id : element.getAttribute('aria-controls');
          this.settings = {
              link: navigate_bar.querySelector('[aria-controls="' + this.id + '"]'),
              container: navigate_bar.querySelector(this.id),
              interaction: element.getAttribute('data-interaction') != undefined ? element.getAttribute('data-interaction') : 'click',
              object_type: element.getAttribute('data-navigate') != undefined ? element.getAttribute('data-navigate') : 'container'
          }

          if (!this.settings.link) {
            return;
          }

          if ( this.id == undefined || this.settings.link == undefined || this.settings.container == undefined ) {
              console.error('Invalid navigation declaration: Invalid element ID', element);
          } else if ( !/^(click|hover|input)$/g.test(this.settings.interaction) ) {
              console.error('Invalid navigation declaration: Invalid [data-interaction] value', element);
          } else if ( !/^(link|container|search)$/g.test(this.settings.object_type) ) {
              console.error('Invalid navigation declaration: Invalid [data-navigate] value', element);
          }
          // debugger;

          this.bind_event(element, state);
          navigate_instances.push(this);
      }

      // Get all navigate instances
      static getInstances(object) {
          if ( object ) {
              let this_instances = [];

              if ( /^(link|container|search)$/g.test(object) ) {
                  navigate_instances.forEach(function(instance) {
                      if ( instance.settings.object_type == object ) {
                          this_instances.push(instance);
                      }
                  });
              } else {
                  navigate_instances.forEach(function(instance) {
                      if ( instance.settings.object_type == 'link' && instance.id == object ) {
                          this_instances.push(instance);
                      }
                  });
              }

              return this_instances;
          }
          return navigate_instances;
      }

      // Fetch mini cart (open = boolean; atc = element)
      static cartRefresh(open, atc) {
          fetch(locale_root + "/cart?view=mini",).then(
              response => { return response.text() }
          ).then(
              html => {
                  // Replace cart mini with fetch data. Update cart count indicator accordingly.
                  navigate_cart.innerHTML = html;
                  let parser = new DOMParser(),
                      cart_count = parser.parseFromString(html, 'text/html').querySelector('.cart-count').innerHTML;
                  navigate_cart_badge.innerHTML = cart_count;

                    document.querySelectorAll('.cart-badge').forEach(badge => {
                        badge.innerText = cart_count;
                    });
                    
                  if ( navigate_bar.querySelector($NAVIGATE_MINICART_TABLE) ) {
                      navigate.renderBundles();
                  }

                  // Open the cart if true
                  if ( open ) {
                      setTimeout(function() {
                          navigate.getInstances('#nav_dropdown_cart').forEach(function(instance) {instance.toggle(true);
                          });

                          if( !navigate_bar.classList.contains('sticky-top') ) {
                              window.scrollTo({top: 0, behavior: 'smooth'});
                          }
                      }, 100);
                  }

                  // If atc exist, re-enable existing elements
                  if ( atc ) {
                      let atc_target = document.querySelectorAll(atc);
                      atc_target.forEach(element => {
                          element.disabled = false;
                          element.classList.remove('loading');
                      });
                  }
              }
          ).catch(
              error => { console.error('Failed to fetch results: ', error) }
          );
      }

      // Update cart quantity; Calls cartRefresh() after.
      static cartUpdate(variant_id, quantity, type) {
          document.querySelectorAll('#cart_mini .option-quantity, #cart_mini .option-remove').forEach(function(element) { element.disabled = true; });

          let array_current_item = variant_id.toString().split(','),
              array_items_quantity = {};
          array_current_item.forEach(id_with_order => {
              let [order,id,key] = id_with_order.split(':');
              if(key) {
                  id += `:${key}`;
              }

              array_items_quantity[id] = parseInt(quantity);
          });

          const data = { updates: array_items_quantity };

          fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
          })
          .then(res => res.json())
          .then(data => {
              const { items } = data;

              this.cartRefresh();
          }).catch(
              error => { if (typeof Sentry != 'undefined') Sentry.captureException(error) }
          );
      }

      // Render bundle line items
      static renderBundles() {
          const cart_table = document.querySelector($NAVIGATE_MINICART_TABLE),
                bundle_list = navigate.formatBundleData();

          for (let bundle in bundle_list) {
              let bundle_title = '',
                  bundle_id = bundle.split(','),
                  bundle_quantity = 0,
                  bundle_price_shopify_one = 0,
                  bundle_price_msrp_one = 0,
                  bundle_itemlist = '',
                  bundle_img = '',
                  bundle_crossselling = '',
                  product_url = '',
                  bundle_quantity_id = [];

              for (let key in bundle_list[bundle]) {
                  switch(key) {
                      case 'bundle_title':
                          bundle_title = bundle_list[bundle][key];
                          break;
                      case 'bundle_type':
                      case 'sku':
                        product_url = "/products/magnus-pro?sku=" + bundle_list[bundle]['sku'];
                        break;
                      case 'quantity':
                          bundle_quantity = parseInt(bundle_list[bundle][key]);
                          break;
                      case 'img':
                          bundle_img = bundle_list[bundle][key];
                          break;
                      case 'crossselling':
                          bundle_crossselling = bundle_list[bundle][key];
                          break;
                      default:
                          let product_title = `<b>${bundle_list[bundle][key].product_title}</b>`,
                              variant_title = bundle_list[bundle][key].variant_title != undefined ? `<br>${bundle_list[bundle][key].variant_title}` : '',
                              variant_preorder = bundle_list[bundle][key].variant_preorder != undefined ? `<br><span class="text-primary">${bundle_list[bundle][key].variant_preorder}</span>` : '';

                          bundle_quantity_id.unshift( bundle_list[bundle][key].lineitem_index + ':' + bundle_list[bundle][key].lineitem_key );
                          bundle_price_shopify_one += bundle_list[bundle][key].price_shopify;

                          bundle_itemlist = `${bundle_itemlist} <div class="border-top py-1 order-${bundle_id.indexOf(key)}">${product_title + variant_title + variant_preorder}</div>`;
                          break;
                  }
              }
              let bundle_price_shopify_total = bundle_price_shopify_one * bundle_quantity;
                  // bundle_price_msrp_total = bundle_price_msrp_one * bundle_quantity;

              let template_item = document.createElement('template');
                  template_item.innerHTML = $NAVIGATE_LINEITEM_STRUCTURE
                      .replace('<!-- product_img -->', bundle_img)
                      .replace('<!-- product_url -->', product_url)
                      .replace('<!-- product_bundle_title -->', bundle_title)
                      .replace('<!-- product_bundle_price_shopify_one -->', currency_symbol + bundle_price_shopify_one)
                      .replace('<!-- product_bundle_price_shopify_total -->', currency_symbol + bundle_price_shopify_total)
                      // .replace('<!-- product_bundle_price_msrp_total -->', bundle_price_msrp_total)
                      .replaceAll('<!-- quantity_id -->', bundle_quantity_id)
                      .replace('<!-- quantity_up -->', bundle_quantity + 1)
                      .replace('<!-- quantity_current -->', bundle_quantity)
                      .replace('<!-- quantity_down -->', bundle_quantity - 1)
                      .replace('<!-- product_bundle_items -->', bundle_itemlist)
                      .replace('<!-- product_cross_selling -->', bundle_crossselling);
                  template_item = template_item.content.firstChild;

              cart_table.prepend(template_item);
          }
      }

      // Consolidate bundle data from cart line item
      static formatBundleData() {
          const cart_table = document.querySelector($NAVIGATE_MINICART_TABLE),
                cart_bundle_items = cart_table.querySelectorAll($NAVIGATE_LINEITEM_BUNDLE);

          let cart_bundle_array = {};
          cart_bundle_items.forEach(item => {
              const itemSku = item.getAttribute('data-sku')?.toLowerCase();
              if(itemSku.includes('slgiftcard') || itemSku.includes('chairtoken') || itemSku.includes('-vertistd')) {
                  return;
              }

              const item_bundle_properties = item.getAttribute($NAVIGATE_LINEITEM_BUNDLE_PROPERTIES),
                    curr_array = cart_bundle_array[item_bundle_properties] || {},
                    curr_crossselling = item.querySelector($NAVIGATE_LINEITEM_VARIANT_CROSSSELLING);

              curr_array[item.getAttribute($NAVIGATE_LINEITEM_VARIANT_ID)] = {
                  'lineitem_key': item.getAttribute($NAVIGATE_LINEITEM_KEY),
                  'product_title': item.getAttribute($NAVIGATE_LINEITEM_PRODUCT_TITLE),
                  'variant_title': item.getAttribute($NAVIGATE_LINEITEM_VARIANT_TITLE),
                  'variant_preorder': item.getAttribute($NAVIGATE_LINEITEM_VARIANT_PREORDER),
                  'price_shopify': parseInt(item.getAttribute($NAVIGATE_LINEITEM_PRICE_SHOPIFY)),
                  'price_msrp': parseInt(item.getAttribute($NAVIGATE_LINEITEM_PRICE_MSRP)),
                  'lineitem_index': parseInt(item.getAttribute($NAVIGATE_LINEITEM_INDEX))
              };

              if ( item.getAttribute($NAVIGATE_LINEITEM_BUNDLE_MAIN) == 'true' ) {
                  curr_array['bundle_title'] = item.getAttribute($NAVIGATE_LINEITEM_BUNDLE_TITLE);
                  curr_array['quantity'] = parseInt(item.getAttribute($NAVIGATE_LINEITEM_QUANTITY));
                  curr_array['img'] = item.querySelector($NAVIGATE_LINEITEM_VARIANT_IMG).outerHTML;
                  curr_array['bundle_type'] = item.getAttribute($NAVIGATE_LINEITEM_TYPE);
                  curr_array['sku'] = item.getAttribute($NAVIGATE_LINEITEM_SKU);
              }

              if ( curr_crossselling != null ) {
                  curr_array['crossselling'] = (curr_array['crossselling'] != undefined ? curr_array['crossselling'] : '') + curr_crossselling.outerHTML;
              }

              cart_bundle_array[item_bundle_properties] = curr_array;
          });
          return cart_bundle_array;
      }

      // Init quick search
      search_query(event) {
          // If keyup == enter; Clear timeout, do nothing.
          if ( event.keyCode == 13 ) {
              clearTimeout(navigate_delayHandler['search']);
              return;
          }

          let search_value = event.currentTarget.value;
          if ( search_value == '' ) {
              clearTimeout(navigate_delayHandler['search']);
              document.querySelectorAll('.search-suggestion').forEach( el => el.style.display = 'block' );
              document.querySelectorAll('.search-loader, .search-result').forEach( el => el.style.display = 'none' );
          } else if ( search_value != navigate_search.last_value ) {
              navigate_search.last_value = search_value;

              document.querySelectorAll('.search-dropdown, .search-loader').forEach( el => el.style.display = 'block' );
              document.querySelectorAll('.search-suggestion, .search-result').forEach( el => el.style.display = 'none' );

              clearTimeout(navigate_delayHandler['search']);
              navigate_delayHandler['search'] = setTimeout(function() {
                  fetch(locale_root + '/search?view=results&q=' + search_value).then(
                      response => { return response.text() }
                  ).then(
                      html => {
                          navigate_bar.querySelectorAll('.search-result').forEach(el => {
                              el.innerHTML = html;
                              el.style.display = 'block';
                          })

                          initLazyload();

                          navigate_bar.querySelectorAll('.search-loader').forEach(el => {
                              el.style.display = 'none';
                          })

                      }
                  ).catch(
                      error => { console.error('Failed to fetch results: ', error) }
                  );
              }, 750);
          }
      }

      // Function handling search toggle
      toggle_search() {
          // Toggle Search
          this.settings.link.setAttribute('aria-expanded', this.next_state);
          switch ( this.next_state ) {
              case true:
                  navigate_search.input.focus();
                  navigate_bar.classList.add('search-active');
                  if ( this.settings.container.classList.contains('topple-horizontal') ) {
                      this.settings.container.style.width = this.settings.container.scrollWidth + 'px';
                  }

                  this.toggle_close_others();
                  navigate_content.scrollTo({top: 0, behavior: 'smooth'});
                  navigate_search.results.scroll(0, 0);
                  break;
              case false:
                  navigate_search.input.blur();
                  navigate_bar.classList.remove('search-active');
                  if ( this.settings.container.classList.contains('topple-horizontal') ) {
                      this.settings.container.style.width = '';
                  }
          }
      }

      // Function handling main navigation toggle
      toggle_navigation() {
          // If mobile navigation: Enable/Disable page scroll.
          if ( '#nav_dropdown_mobile #nav_dropdown_cart'.includes(this.id) && screen_isMobile() ) {
              switch ( this.next_state ) {
                  case true:
                      let close_id = this.id == '#nav_dropdown_mobile' ? '#nav_dropdown_cart' : '#nav_dropdown_mobile';
                      navigate.getInstances(close_id).forEach(function(instance) {
                          instance.toggle(false);
                      });

                      if ( this.id == '#nav_dropdown_mobile' ) {
                          setTimeout(function() {
                              navigate.getInstances('#nav_dropdown_shopnow').forEach(function(instance) {
                                  instance.toggle(true);
                              });
                          }, 10);
                      }

                      document.body.classList.add('overflow-hidden');
                      navigate_bar.classList.add('mobile-active');
                      break;
                  case false:
                      document.body.classList.remove('overflow-hidden');
                      navigate_bar.classList.remove('mobile-active', 'search-active');
                      navigate_content.scrollTo({top: 0, behavior: 'smooth'});
                      navigate_search.cancel.style.width = 0;
                      removeActiveNavClass(null, true)
                      attachScrolledClass(true)
              }
          }

          // If link attribute already reflects next_state, do nothing.
          if ( this.next_state == (this.settings.link.getAttribute('aria-expanded') == 'true') ) {
              return;
          }

          // Functions past this point handles slide animation
          // Note: Order of css changes matters for animation
          this.settings.link.setAttribute('aria-expanded', this.next_state);
          this.settings.container.classList.remove('topple', 'show');
          if ( this.next_state ){ navigate_bar.classList.add('interacted'); this.settings.container.classList.add('toppling', 'show'); }
          if ( this.settings.container.style.height == '' ){ this.settings.container.style.height = this.settings.container.scrollHeight + 'px'; }
          if ( !this.next_state ){ navigate_bar.classList.remove('interacted'); this.settings.container.classList.add('toppling'); }

          let _this = this;
          clearTimeout(navigate_delayHandler[this.id]);
          navigate_delayHandler[this.id] = setTimeout(function() {
              if ( !_this.next_state ){ _this.settings.container.style.height = ''; }

              navigate_delayHandler[this.id] = setTimeout(function(){
                  _this.settings.container.classList.remove('toppling');
                  _this.settings.container.classList.add('topple');
                  _this.settings.container.style.height = '';

              }, 350);
          }, 10);
      }

      // Function to close active toggleables
      toggle_close_others() {
          let _this = this;
          navigate.getInstances().forEach(function(instance) {
              if ( !('#nav_dropdown_mobile #nav_dropdown_cart ' + _this.id).includes(instance.id) ) {
                  instance.toggle(false);
              }
          });
      }

      // Splits toggle task into toggle_navigation and toggle_search based on event
      toggle(state, event) {
          // Define next state
          if ( typeof state != 'boolean' ) {
              if ( event == undefined ) {
                  console.error('Invalid toggle() function parameters.');
              }

              this.next_state = this.interaction_handler(null, event);
              if ( this.next_state == null ) { return; }
          } else {
              this.next_state = state;
          }

          // Quick Search
          if ( this.next_state == 'quick-search' ) {
              this.search_query(event);
              return;
          }

          // Toggle Search
          if ( this.settings.object_type == 'search' ) {
              this.toggle_search();
              return;
          }

          // Toggle Navigation
          this.toggle_navigation();
      }

      // Determine next_state based on event
      // Note: Order of event.type is important.
      interaction_handler(state, event) {
          if ( typeof state == 'boolean' ) {
              return state;
          }

          let next_state = undefined;

          if ( event ) {
              if ( screen_isMobile() && (event.type == 'mouseenter' || event.type == 'mouseleave') ) {
                  return null;
              }

              switch ( event.type ) {
                  case 'keyup':
                      return 'quick-search';
                  case 'focus':
                      return true;
                  case 'touchstart':
                      return null; // If touchstart, prevent click.
                  case 'touchmove':
                      navigate_touchCancel = true; // If user deviates from start position, cancel event.
                      return null;
                  case 'touchend':
                      if ( navigate_touchCancel ) {
                          navigate_touchCancel = false;
                          return null;
                      }
                      this.toggle_close_others();
                      event.preventDefault(); // Prevent href links from occurring.
                      break;
                  case 'click':
                      if ( screen_isMobile() ) {
                          this.toggle_close_others();
                          event.preventDefault();
                      } else if (event.target.closest('a') != null) {
                          if (event.target.closest('a').matches('[data-navigate=link][data-interaction=hover]')) {
                              return null;
                          }
                      }
                      break;
                  case 'mouseenter':
                      next_state = true;
                      break;
                  case 'mouseleave':
                      next_state = false;
              }
          }

          if ( next_state == undefined ) {
              next_state = this.settings.link.getAttribute('aria-expanded') == 'true' ? false : true;
          }

          return next_state;
      }

      // Binds event based on this.settings
      bind_event(element) {
          switch ( this.settings.object_type ) {
              case 'link':
                  // Bind navigation topple events (Click only)
                  if ( this.settings.interaction == 'click' ) {
                      element.onclick = event => this.toggle(null, event);
                      return;
                  }

                  // Bind navigation topple events (Hover; On Link)
                  element.ontouchstart = element.ontouchmove = element.ontouchend = element.onclick = element.onmouseenter = element.onmouseleave = event => this.toggle(null, event);
                  return;
              // Bind navigation topple events (Hover; On Container)
              case 'container':
                  element.onmouseenter = element.onmouseleave = event => this.toggle(null, event);
                  return;
              case 'search':
                  if ( this.settings.interaction  == 'input' ) {
                      element.onkeyup = element.onfocus = event => this.toggle(null, event);
                      return;
                  }

                  element.onclick = event => this.toggle(null, event);
          }
      }
  }
  // Bind navigation topple events
  navigate_topple.forEach( element => new navigate(element) );
  // Reset navigation states
  window.addEventListener('resize', function() {
      if ( screen_width == window.outerWidth ) {
          return;
      }
      screen_width = window.outerWidth;

      navigate_bar.querySelector('#nav_dropdown_mobile').classList.remove('show');
      document.body.classList.remove('overflow-hidden');
      navigate_bar.classList.remove('search-active', 'mobile-active');

      navigate.getInstances('link').forEach( instance => instance.toggle(false) );
      navigate.getInstances('search').forEach( instance => instance.toggle(false) );
  });
  // Navigation Transparent Scrolled; Init onload
  if ( navigate_bar.classList.contains('trans') ) {
      window.addEventListener('scroll', function(event) {
          if ( window.scrollY > 75 ) {
              navigate_bar.classList.add('scrolled');
              return;
          }
          navigate_bar.classList.remove('scrolled');
      })
  }
  if ( window.scrollY > 75 ) {
      navigate_bar.classList.add('scrolled');
  }
  // Bind minicart quantity change event and cart close event
  if ( navigate_cart != undefined ) {
      navigate_cart.addEventListener('click', function(event) {
          if ( event.target.getAttribute('cart-quantity') ) {
              navigate.cartUpdate(event.target.getAttribute('variant-id'), event.target.getAttribute('cart-quantity'), event.target.dataset.type);
          }
          if ( event.target.classList.contains('cart-close') ) {
              navigate.getInstances('#nav_dropdown_cart').forEach(function(instance) {
                  instance.toggle(false);
              });
          }
      });

      // Render Bundles
      if ( navigate_bar.querySelector($NAVIGATE_MINICART_TABLE) ) {
          navigate.renderBundles();
      }
  }
  // CSS Pageload Animation Fix
  navigate_bar.querySelector('.search-input').classList.add('loaded');

  const navSearchMobile = document.querySelector('.nav-search-mobile');

  if (navSearchMobile) {
    document.querySelector('.nav-search-mobile').addEventListener("click", () => {
      const eleSearchDropdown = document.querySelector('#nav_dropdown_mobile');

      if (eleSearchDropdown.classList.contains("show")) {
        eleSearchDropdown.classList.remove("show");
      } else {
        eleSearchDropdown.classList.add("show");
        document.querySelector("#nav_dropdown_mobile .search-input .nav-mobile-search input").focus();
      }
    });
  }

  document.querySelector("#nav_dropdown_mobile .search-input #nav_search_cancel").addEventListener("click", () => {
    const eleSearchDropdown = document.querySelector('#nav_dropdown_mobile');
    eleSearchDropdown.classList.remove("show");
  });

  /**
   * Main nav hover with debounce
   * This is to match the debounce times in react for the main nav hover
   */
  const navMainContainer = document.querySelector(".nav-main");

  let debounceTimerNavHover;
  const updateMainNavHoverClass = (fn, delay = 550) => {
    clearTimeout(debounceTimerNavHover)
    debounceTimerNavHover = setTimeout(fn, delay)
  }
  navMainContainer.addEventListener("mouseleave", (event) => {
    event.stopPropagation();
    updateMainNavHoverClass(() => {
      navMainContainer.classList.add("is-not-hovered");
    });
  });

  navMainContainer.addEventListener("mouseenter", (event) => {
    event.stopPropagation();
    updateMainNavHoverClass(() => {
      navMainContainer.classList.remove("is-not-hovered");
    }, 0);
  });

  /* ==========================================================================
      Secretlab Analytics

      add necessary documentation here
  ========================================================================== */
  class analytics {}

  var index_umd = {
      navigate,
      analytics
  }
  return index_umd;
}));